/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions*/

import React, { Component, useContext, useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Form, Formik } from "formik";
import Colors from "constants/Colors";
import { differenceInDays } from 'date-fns';
import ListEnquiryButtons from 'components/ListEnquiryButtons';
import { GlobalAuthContext } from "store/context";
import { Layout, Text} from "components";
import { FitinsurAPI, MessageCenter, CacheManager } from "utils";
import {
  Content,
  LoadContainer,
  ButtonContainer,
  Circle
} from "./styles";
import { Button } from "components/index";
import {
  LoaderContext,
} from '@fitinsur/contexts';
import {
  Label,
  ListHeader,
  ResponsiveTable,
  ModalLost,
  ModalConfirmation,
  DialogComponent
} from '@fitinsur/components';
import { 
  useGetRenewalsList,
  useCreateRenewal,
  useGetRenewalsExport
} from '@fitinsur/services/OperationService';
import { 
  useGetQuery,
  useGetStatusOptions
} from '@fitinsur/services/QuestionnairesService';
import ContentCard from 'components/ContentCard/index';
import Icon from "components/Icon";
import { useTextMessage } from '@fitinsur/hooks';

const initialFilterData = [
  { label: "APÓLICE", type: "text", key: "operationReferenceNumber"},
  { label: "RENOVAÇÃO", type: "text", key: "renewalQuoteReference" },
  { label: "COTAÇÃO", type: "text", key: "idOperationRenewalQuote" },
  { label: "CORRETORA", orderKey: "orderBroker", key: "brokerId", type: "list" },
  { label: "MODALIDADE", orderKey: "orderModality", key: "typeOfApplication", type: "multi-list", value: [7115, 7116, 7117, 7118, 8162, 8163] },
  { label: "USUÁRIO", orderKey: 'orderUser', key: 'userName', type: 'text' },
  { label: "TOMADOR", type: "text", key: "borrower" },
  { label: "DATA DE VENCIMENTO", type: "date", key: "expiryDate" },
  { label: "DATA DA RENOVAÇÃO", type: "date", key: "renewalsDate" },
  { label: "MOTIVO DO DECLÍNIO", orderKey: 'declineReason', key: 'declineReason', type: 'list' },
  { label: "SITUAÇÃO", orderKey: "orderStatus", key: "renewalStatus", type: "list" }
];

export default function Renewals({ permissions }) {
  const authContext = useContext(GlobalAuthContext);
  const cache = new CacheManager();
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const { getDescription } = useTextMessage();
  const { updateIsLoadingStatus } = useContext(LoaderContext);
  const history = useHistory();
  const location = useLocation();
  const formik = useRef();
  
  const region = authContext.region === 'en-GB' ? 'en' : authContext.region;
  const storedFilterOption = localStorage.getItem('renewals-filter-sompo');
  const storedStringFilterOption = localStorage.getItem('str-renewals-filter-sompo');
  let quotesUrl = '/renewals' + (storedStringFilterOption ? '?' + storedStringFilterOption : '');
  
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [listData, setListData] = useState([]);
  const [message, setMessage] = useState([null]);
  const [brokerList, setBrokerList] = useState([]);
  const [products, setProducts] = useState(
    [
      {
        label: "NENHUM PRODUTO DISPONÍVEL",
        value: ""
      }
    ]
  );
  const [modalities, setModalities] = useState([]);

  const [optionsStatus, setOptionsStatus] = useState([]);
  const [currentOperation, setCurrentOperation] = useState(null);
  const [filterData, setFilterData] = useState(storedFilterOption ? 
    JSON.parse(storedFilterOption) : 
    initialFilterData
  );
  const [sortBy, setSortBy] = useState({
    key: "idOperation",
    direction: "ASC"
  });
  const [showModalLost, setShowModalLost] = useState(false)
  const [showModalConfirmation, setShowModalConfirmation] = useState(false)

  const [dialog, setDialog] = useState({
    visible: false,
    title: '',
    icon: 'exclamation',
    args: null
  });  

  const {
    data: getRenewalsListData,
    loading: getRenewalsListLoading,
    error: getRenewalsListError,
    status: getRenewalsListStatus,
    request: getRenewalsListRequest,
  } = useGetRenewalsList();

  const {
    data: useCreateRenewalData,
    loading: useCreateRenewalLoading,
    error: useCreateRenewalError,
    status: useCreateRenewalStatus,
    request: useCreateRenewalRequest,
} = useCreateRenewal(currentOperation);

  const {
    request: useGetQueryRequest,
    loading: useGetQueryLoading,
  } = useGetQuery();

  const {
    request: getStatusOptionsRequest,
    loading: useGetStatusOptionsLoading,
  } = useGetStatusOptions();

  const {
    data: useGetRenewalsListExportData,
    loading: useGetRenewalsListExportLoading,
    error: useGetRenewalsListExportError,
    status: useGetRenewalsListExportStatus,
    request: useGetRenewalsListExportRequest,
  } = useGetRenewalsExport();

  useEffect(() => {
    updateIsLoadingStatus(
      getRenewalsListLoading ||
      useCreateRenewalLoading ||
      useGetQueryLoading ||
      useGetStatusOptionsLoading
    );
  }, [
    getRenewalsListLoading,
    useCreateRenewalLoading,
    useGetStatusOptionsLoading,
    useGetQueryLoading,
  ]);

  useEffect(() => {
    if (getRenewalsListStatus === 200) {   
      if (getRenewalsListData?.pagination?.page === 1) {
        setListData(getRenewalsListData.value);
      } else {
        setListData([...listData, ...getRenewalsListData.value]);
      }
      setTotalPages(+getRenewalsListData?.pagination?.totalPages);
    }
  }, [getRenewalsListStatus]);

  useEffect(() => {
    getRenewalsListRequest(null, {
      loadLastDocument: true,
      loadOperationPersonRoles: true,
      page: 1,
      idQstEndOfTerm: 3448,
      declineReasonQst: 3458,
      idQuestionApplicationType: [3403],
      idsDomain: [27],
      sortBy,
      ...(filterData.filter(v => v.value).reduce((a, b) => {
        a[b.key] = b.value;
        return a
      }, {}))
    });

    cache.getMessage(
      "NO_ITEMS_LIST", region, "355", authContext.token
    ).then(msg => setMessage(msg)).catch(err => console.log("error", err));
  }, []);

  useEffect(() => {
    if (useCreateRenewalStatus === 200) {
      const { idProduct, idOperation } = useCreateRenewalData?.value || {};
      history.push(`/edit-enquiry/${idProduct}/${idOperation}`);
    } else if (useCreateRenewalStatus === 400) {
      mc.error(
        "Há um fluxo de endosso em andamento nesta apólice. Renovação para apólice em fluxo de endosso não é permitido. Favor entre em contato com a subscrição"
      );
    }
  }, [useCreateRenewalStatus]);

  const initialValues = {
    filter: {
      number: "",
      firstName: "",
      fullName: "",
      hierarchy: "",
      parent: "",
      holding: "",
      personStatus: "",
    },
  };

  const columns = [
    {
      title: "APÓLICE",
      value: "idOperation",
      key: "idOperation",
      sortKey: "idOperation",
      minWidth: 14,
      maxWidth: 14,
      color: (item) => handleColorLabel(item),
      component: (listItem) => (
        <Label wordWrap fontSize={13} color={handleColorLabel(listItem)}>
          <Circle>
            {listItem?.automaticRenovation ? 'A' : 'M'}
          </Circle>
          <br/>{listItem.operationReferenceNumber}
        </Label>
      )
    },
    {
      title: "RENOVAÇÃO",
      value: "renewalQuoteReference",
      key: "renewalQuoteReference",
      sortKey: "renewalQuoteReference",
      minWidth: 14,
      maxWidth: 14,
      color: (item) => handleColorLabel(item)
    },
    {
      title: "COTAÇÃO",
      value: "idOperationRenewalQuote",
      key: "idOperationRenewalQuote",
      sortKey: "idOperationRenewalQuote",
      minWidth: 14,
      maxWidth: 14,
      color: (item) => handleColorLabel(item)
    },
    {
      title: "CORRETORA",
      value: "broker",
      key: "brokerName",
      sortKey: "broker",
      minWidth: 16,
      maxWidth: 16,
      color: (item) => handleColorLabel(item),
      component: (lisItem) => {
        return (
          <Label wordWrap fontSize={12} color={handleColorLabel(lisItem)}>
            {lisItem?.brokerRenewalQuote || lisItem?.brokerName || ''}
          </Label>
        )
      }
    },
    {
      title: "USUÁRIO",
      key: "userName",
      sortKey: 'orderUser',
      minWidth: 14,
      maxWidth: 14,
      color: (item) => handleColorLabel(item)
    },
    {
      title: "MODALIDADE",
      value: "typeOfApplication",
      key: "typeOfApplication",
      sortKey: "typeOfApplication",
      minWidth: 16,
      maxWidth: 16,
      color: (item) => handleColorLabel(item)
    },
    {
      title: "TOMADOR",
      value: "borrower",
      key: "borrower",
      sortKey: "borrower",
      minWidth: 14,
      maxWidth: 14,
      color: (item) => handleColorLabel(item)
    },
    {
      title: 'DIAS A VENCER',
      minWidth: 14,
      maxWidth: 14,
      color: (item) => handleColorLabel(item),
      component: (listItem) => {
        if (!listItem) return null;
      
        const difference = differenceInDays(new Date(listItem.expiryDate), new Date());
      
        return (
          <Label wordWrap fontSize={12} color={handleColorLabel(listItem)}>
            {difference}
          </Label>
        );
      }
    },
    {
      title: "IS",
      value: "maxLimClaim",
      key: "maxLimClaim",
      sortKey: "maxLimClaim",
      minWidth: 14,
      maxWidth: 14,
      color: (item) => handleColorLabel(item),
      component: (listItem) => {
        if(!listItem) return null;
        return (
          <Label wordWrap fontSize={12} color={handleColorLabel(listItem)}>
            {listItem.maxLimClaim 
              ? Number(listItem.maxLimClaim).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) 
              : '-'}
          </Label>
        )
      }
    },
    {
      title: "DATA DE VENCIMENTO",
      value: "expiryDate",
      key: "expiryDate",
      sortKey: "expiryDate",
      minWidth: 14,
      maxWidth: 14,
      color: (item) => handleColorLabel(item),
      component: (lisItem) => {
        return (
          <Label wordWrap fontSize={12} color={handleColorLabel(lisItem)}>
            {lisItem?.expiryDate ? new Date(lisItem.expiryDate).toLocaleDateString('pt-br') : "-"}
          </Label>
        )
      }
    },
    {
      title: "DATA DA RENOVAÇÃO",
      value: "renewalDate",
      key: "renewalDate",
      sortKey: "renewalDate",
      minWidth: 14,
      maxWidth: 14,
      color: (item) => handleColorLabel(item),
      component: (lisItem) => {
        return (
          <Label wordWrap fontSize={12} color={handleColorLabel(lisItem)}>
            {lisItem?.renewalDate ? new Date(lisItem.renewalDate).toLocaleDateString('pt-br') : "-"}
          </Label>
        )
      }
    },
    {
      title: "MOTIVO DO DECLÍNIO",
      key: "declineReason",
      sortKey: 'declineReason',
      minWidth: 14,
      maxWidth: 14,
      color: (item) => handleColorLabel(item)
    },
    {
      title: "SITUAÇÃO",
      value: "renewalDomainStatusDescription",
      key: "renewalDomainStatusDescription",
      sortKey: "renewalStatus",
      minWidth: 15,
      maxWidth: 15,
      color: (item) => handleColorLabel(item),
      component: (lisItem) => {
        const integrationErrors = lisItem?.operationMetadataRenewalQuote?.integrationErrors;
        return (
          <Label wordWrap fontSize={12} color={handleColorLabel(lisItem)}>
            {integrationErrors?.length && 
              integrationErrors?.some((error) => error.showInPopup) &&
              lisItem?.idDomainStatusRenewalQuote === 10 &&
              <Icon
                name='exclamation' 
                style={{ margin: 0, marginBottom: -5 }}
                onClick={() => createModalIntegrationErrors(integrationErrors)}
              />
            }            
            {lisItem?.renewalDomainStatusDescription}
          </Label>
        )
      }      
    },
    {
      title: "AÇÕES",
      key: "action",
      minWidth: 8,
      maxWidth: 8,
      paddingRight: 5,
      component: (listItem) => <ListEnquiryButtons
        editRoute={checkOperationRoute}
        listItem={listItem}
        idOperation={listItem.idOperation}
        permissions={permissions || {}}
        authContextToken={authContext?.token}
        showDeclineIcon={permissions.NBI_REQUEST_APPROVE_REJECT}
        showRenewalsIcon={true}
        toDocument={() => history.push(`/broking/document-management/${listItem.idOperation}`)}
        setShowModalLost={() => {
          setCurrentOperation(listItem.idOperation)
          setShowModalLost(true)
        }}
        setShowModalConfirmation={() => {
          setCurrentOperation(listItem.idOperation)
          setShowModalConfirmation(true)
        }}
      />
    },
  ];

  const handleColorLabel = (item) => {
    if (item.isRejected) return Colors.GRAY[3];
    else if (item.isApproved) return Colors.GRAY[0];
    else if (item.idDomainStatusOper === 4 && item?.additionalInformation) return Colors.RED;
    else if (item?.idDomainStatusRenewalQuote === 10 && item?.operationMetadataRenewalQuote?.integrationErrors?.length>0) return Colors.RED;
    else if (item.mediationFinished) return Colors.TERTIARY;
    else return null;
  }

  function handleSortList(key) {
    if (key === 'action' || key === 'status') return;
    let sort;
    if (sortBy.key === key && sortBy.direction === 'ASC') {
      sort = { key: key, direction: 'DESC' };
      setSortBy(sort);
    } else if (sortBy.key === key && sortBy.direction === 'DESC') {
      sort = { key: null, direction: null };
      setSortBy(sort);
    } else {
      sort = { key: key, direction: 'ASC' };
      setSortBy(sort);
    };
    getRenewalsListRequest(null, {
      loadLastDocument: true,
      loadOperationPersonRoles: true,
      page: 1,
      idQstEndOfTerm: 3448,
      declineReasonQst: 3458,
      idQuestionApplicationType: [3403],
      idsDomain: [27],
      sortBy: sort,
      ...(filterData.filter(v => v.value).reduce((a, b) => {
        a[b.key] = b.value;
        return a
      }, {}))
    });
  }


  const handleFilter = (resetFilter) => {
      const cleanFilter = initialFilterData.map((f) => {
        if(f.label === 'MODALIDADE') {
          return {...f, value: undefined};
        }
        return f;
      });
      quotesUrl = quotesUrl + (
        localStorage.getItem('str-renewals-filter-sompo') ?
        '?' + localStorage.getItem('str-renewals-filter-sompo') : ''
      )
      setCurrentPage(1);
      
      const refFilterData = resetFilter ? cleanFilter : filterData;
      
      getRenewalsListRequest(null, {
        loadLastDocument: true,
        loadOperationPersonRoles: true,
        page: 1,
        idQstEndOfTerm: 3448,
        declineReasonQst: 3458,
        idQuestionApplicationType: [3403],
        idsDomain: [27],
        sortBy,
        ...(refFilterData.filter(v => v.value).reduce((a, b) => {
          a[b.key] = b.value;
          return a
        }, {}))
      });      
      if (resetFilter) {
      setFilterData(cleanFilter);
      localStorage.removeItem('str-renewals-filter-sompo');
      localStorage.setItem('renewals-filter-sompo', JSON.stringify(cleanFilter));
      history.push('/renewals');
    } else {
    history.push(`${quotesUrl}`)
  }
};

const exportRenewals = async (page = 1, sort = {}) => {
  let exportList = sessionStorage.getItem('texel-export-list-report');
  let list = [];
  if (exportList) list = JSON.parse(sessionStorage.getItem('texel-export-list-report'))
  let verify = list.length > 0 ? list.filter(item => item.nameList == 'Relátorio de Renovações') : false;

  if (!verify || verify.length == 0) {
      updateIsLoadingStatus(true);
      setTimeout(() => updateIsLoadingStatus(false), 1000);
      useGetRenewalsListExportRequest(null, {
        loadLastDocument: true,
        loadOperationPersonRoles: true,
        page: 1,
        idQstEndOfTerm: 3448,
        declineReasonQst: 3458,
        idQuestionApplicationType: [3403],
        idsDomain: [27],
        sortBy,
        ...(filterData.filter(v => v.value).reduce((a, b) => {
          a[b.key] = b.value;
          return a
        }, {}))
      });
        sessionStorage.setItem('init-texel-export-list-report', 'processing Id');
  } else {
      mc.error("Por favor, aguarde o download do relatório de renovações ser finalizado.");
  }
}

useEffect(() => {
  if (!useGetRenewalsListExportStatus) return;
  if (useGetRenewalsListExportStatus === 200) {
      let exportList = sessionStorage.getItem('texel-export-list-report');
      let list = [];
      if (exportList) list = JSON.parse(sessionStorage.getItem('texel-export-list-report'))
      let verify = list.length > 0 ? list.filter(item => item.nameList == 'Relátorio de Renovações') : false;
      if (!verify || verify.length == 0) {
          sessionStorage.removeItem('texel-export-list-report');
          const document = useGetRenewalsListExportData;
          if (document.idDocument) {
              list.push({ idDocument: document.idDocument, processing: true, nameList: 'Relátorio de Renovações' });
              sessionStorage.setItem('texel-export-list-report', JSON.stringify(list));
            }
      } else {
        mc.error("Por favor, aguarde o download do relatório de renovações ser finalizado.");
      }

  }
}, [useGetRenewalsListExportStatus])

  function setNextPage() {
    setCurrentPage(currentPage + 1)
    getRenewalsListRequest(null, {
      loadLastDocument: true,
      loadOperationPersonRoles: true,
      page: currentPage + 1,
      declineReasonQst: 3458,
      idQuestionApplicationType: [3403],
      idQstEndOfTerm: 3448,
      idsDomain: [27],
      sortBy,
      ...(filterData.filter(v => v.value).reduce((a, b) => {
        a[b.key] = b.value;
        return a
      }, {}))
    });
  }

  const requestBrokerList = async () => {
    const { data } = await useGetQueryRequest({
      id: 'fitQueryPersonBroker',
      params: {
        id: "fitQueryPersonBroker",
        queryTail: true,
        personName: ''
      }
    });

    try {
      if (data.ret_code !== 200) return;

      const persons = data.ret_value.map(person => ({
        ...person,
        label: person.personName,
        value: person.id
      }));

      setBrokerList(persons)
    } catch (err) {
      console.log("err fitQueryPersonBroker", err)
    };
  };

    const requestModalitesList = async () => {
    const { data } = await useGetQueryRequest({
      id: 'getSompoModalities',
      params: {}
    });

    try {
      if (data.ret_code !== 200) return;
      setModalities(data.ret_value)
    } catch (err) {
      console.log("err getSompoModalities", err)
    };
  };

  const requestStatusOptions = async () => {
    const { data: { value: statusRenewals } } = await getStatusOptionsRequest(null, {idDomains: [607]});

    const formattedStatus = statusRenewals.map(
      (status) => ({
        ...status,
        label: status.statusDescription,
        value: status.idDomainStatusList?.join(',') || status.idDomainStatus,
      })
    );

    setOptionsStatus(formattedStatus);
  };

  async function requestProductsList() {
    fitinsur.requestProductsList()
      .then(x => x.json())
      .then(response => {
        if (response.ret_code !== 200) {
          return;
        }
        const options = response.ret_value
          .map(product => ({
            label: product.PRODUCT_NAME,
            value: product.ID_PRODUCT
          }))

        setProducts(options);
      })
      .catch(error => console.log(error));
  }

  const checkOperationRoute = (idOperation, idProduct, idDomainStatusDoc) => {
    fitinsur.setAuthToken(authContext.token);
    updateIsLoadingStatus(true);

    fitinsur.requestPolicyNavigation(idOperation).then(x => x.json()).then(res => {
      if (res.ret_code !== 200) {
        mc.error(res.ret_msg_details);
        return;
      }
      let route = res.ret_value.route || `/edit-enquiry/${idProduct}/${idOperation}`;
      if (route) {
        updateIsLoadingStatus(false);
        history.push({ pathname: route, state: res.ret_value.idNavigation == 99 ? { disabled: true, idProduct: idProduct } : { status: idDomainStatusDoc, idProduct: idProduct } })
      } else {
        mc.error('NAVIGATION NOT DEFINED');
        updateIsLoadingStatus(false);
      }
    }).catch(() => updateIsLoadingStatus(false));
  }

  useEffect(() => {
    requestStatusOptions();
    getRenewalsListRequest(null, {
      loadLastDocument: true,
      loadOperationPersonRoles: true,
      page: 1,
      idQstEndOfTerm: 3448,
      declineReasonQst: 3458,
      idQuestionApplicationType: [3403],
      idsDomain: [27],
      sortBy,
      ...(filterData.filter(v => v.value).reduce((a, b) => {
        a[b.key] = b.value;
        return a
      }, {}))
      
    });

    fitinsur.setAuthToken(authContext.token);
    requestBrokerList();
    requestProductsList();
    requestModalitesList();
    cache.getMessage(
      "NO_ITEMS_LIST", region, "355", authContext.token
    ).then(msg => setMessage(msg)).catch(err => console.log("error", err));
  }, []);

  useEffect(() => {
    updateIsLoadingStatus(getRenewalsListLoading)
  }, [getRenewalsListLoading]);

  const handleOperationFilterLost = (idOperation) => {
    const hideLost = filterData.find(option => option.key === 'hideLostTransactions')?.value;

    if (hideLost) {
      const filteredOperations = listData.filter(operation => operation.idOperation !== idOperation);
      setListData(filteredOperations);
    } else {
      const updatedOperations = listData.map(operation => {
        if (operation.idOperation === idOperation) {
          operation.renewalDomainStatus = 391;
          operation.renewalDomainStatusDescription = 'Cancelado';
          operation.renewalDate = new Date();
        }
        return operation;
      });

      setListData(updatedOperations);
    }
    setShowModalLost(false);
  }

  function createModalIntegrationErrors(integrationErrors) {
    //const errors = integrationErrors.filter((error) => error.service && error.userMessage && error.showInPopup);
    const errors = integrationErrors.filter((error) => error.service && error.userMessage);

    setDialog({
      visible: true,
      title: `Relatório da renovação automática`,
      icon: 'exclamation',
      args: errors,
    })
  }  

  return (
    <Layout title="Renovação">
      <ModalLost
        idOperation={currentOperation}
        show={showModalLost}
        setDialog={setShowModalLost}
        title="Deseja realmente recusar esta renovação ?"
        idQuestion={3458}
        createAndLostOperation={true}
        operationThatReceivedLost={handleOperationFilterLost}
      />
      <ModalConfirmation
        show={showModalConfirmation}
        text="Deseja renovar esta apólice?"
        showTitle={false}
        textButtonCancel="CANCELAR"
        textButtonConfirm="CONFIRMAR"
        onConfirm={() => {
          if (permissions.REHABILITATE_RENEWAL) {
            useCreateRenewalRequest({ idDomain: 607 })
          } else {
            mc.warning(getDescription("DOMAINS", 1113))
            setShowModalConfirmation(false)
          }
        }}
        onCancel={() => {
          setCurrentOperation(null)
          setShowModalConfirmation(false)
        }}
      />
      <DialogComponent icon={dialog.icon} size='60%' show={dialog.visible} setDialog={setDialog}>
        <ContentCard title={dialog.title} noBorder={true}>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <div style={{ width: "100%" }}>
              {dialog.args?.map(arg => {
                return (
                  <p>
                    <span style={{ fontWeight: "bold" }}>{arg?.service}:&nbsp;</span>{arg?.userMessage}<br></br>
                    <span style={{ fontWeight: "bold" }}>Data:&nbsp;</span>{arg?.dateTime}
                  </p>
                )
              })}
            </div>

            <Button
              third
              style={{ marginTop: '20px' }}
              onClick={() => setDialog({ visible: false, title: null, icon: null, args: null })}
            >
              Fechar
            </Button>
          </div>
        </ContentCard>
      </DialogComponent>      
      <Content>
        <Formik
          initialValues={initialValues}
          onSubmit={(values) => handleFilter(values)}
          innerRef={formik}
        >
          {(formikProps) => (
            <Form>
              <ListHeader
                idDomainList={322}
                idApplication={675}
                filterData={filterData}
                setFilterData={setFilterData}
                onHandleFilter={(resetFilter) => handleFilter(resetFilter)}
                listNameSpace={'renewals-filter-sompo'}
                listUrl='/renewals'
                optionsModalities={modalities}
                optionsProduct={products}
                optionsBroker={brokerList}
                optionsStatus={optionsStatus}
                optionsDeclineReason = {[
                  { label: 'Perdido por Preço', value: 6874 },
                  { label: 'Perdido por SLA', value: 6875 },
                  { label: 'Desistiu de Contratar o Seguro', value: 6876 },
                  { label: 'Restrição conforme Parecer de Crédito', value: 6877 },
                  { label: 'Restrição no Contrato de Resseguro', value: 6878 },
                  { label: 'Risco Emitido em Congênere', value: 6879 },
                  { label: 'Risco Emitido com outro Corretor', value: 7388 },
                  { label: 'Risco Fora do Apetite da Seguradora', value: 7389 },
                  { label: 'Sem Retorno do Corretor', value: 7390 },
                  { label: 'Processo Arquivado (Extinção do Risco)', value: 7461 },
                  { label: 'Necessidade de Emissão de Endosso', value: 7469 }
                ]}
                exportList={() =>  exportRenewals(1, sortBy)}
              />

              <ResponsiveTable 
                onSortTable={handleSortList}
                formikRef={formik?.current}
                columns={columns}
                data={listData}
              />
              
              {!listData.length && (
                <ButtonContainer style={{ minHeight: '450px' }}>
                  <Text 
                    style={{ 
                      fontWeight: 'bold',
                      color: Colors.GRAY[1],
                      margin: 'auto',
                      cursor: 'pointer',
                      marginTop: '10px' 
                    }} 
                    onClick={() => { }}
                  >
                    {message || ''}
                  </Text>
                </ButtonContainer>
              )}
            </Form>
          )}
        </Formik>
        <LoadContainer>
          {!listData || listData.length === 0 || currentPage === totalPages ? (
            <Button forth onClick={(e) => e.preventDefault()}>
              NÃO HÁ MAIS ITENS
            </Button>
          ) : (
            <Button forth onClick={() => setNextPage()}>
              + CARREGAR MAIS
            </Button>
          )}
        </LoadContainer>
      </Content>
    </Layout>
  );
}
